import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/auth/ProtectedRoute';

const ProjectsList = lazy(() => import('./ProjectsList'));
const EnterpriseTaskManager = lazy(() => import('./EnterpriseTaskManager'));
const ProjectTimesheets = lazy(() => import('./ProjectTimesheets'));

export const projectsRoutes = (
    <React.Fragment key="projects">
        <Route element={<ProtectedRoute permission="crm.project.view" />}>
            <Route path="/projects" element={<ProjectsList />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.task.view" />}>
            <Route path="/tasks" element={<EnterpriseTaskManager />} />
        </Route>
        <Route element={<ProtectedRoute permission="crm.timesheet.view" />}>
            <Route path="/projects/timesheets" element={<ProjectTimesheets />} />
        </Route>
    </React.Fragment>
);
